function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLinkIcon = function SvgLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.966 11.25a.946.946 0 0 1-.662-.274.942.942 0 0 1 0-1.33l2.004-1.999a1.887 1.887 0 0 0 .41-2.056 1.887 1.887 0 0 0-.41-.613L14.966 3.64a1.95 1.95 0 0 0-2.676 0l-2.004 2a.947.947 0 0 1-1.534-.68.942.942 0 0 1 .201-.64l2.004-2a3.88 3.88 0 0 1 5.351 0l1.333 1.33a3.772 3.772 0 0 1 .82 4.113c-.19.458-.468.874-.82 1.225l-2.014 1.99a.946.946 0 0 1-.661.273Zm-8.675 7.5c-.49 0-.974-.097-1.426-.287a3.722 3.722 0 0 1-1.21-.82L2.343 16.31a3.787 3.787 0 0 1-.808-1.227 3.833 3.833 0 0 1 .808-4.125l1.984-2.005a.922.922 0 0 1 1.237.076.953.953 0 0 1 .067 1.257l-1.974 2.005a1.894 1.894 0 0 0-.547 1.338 1.917 1.917 0 0 0 .547 1.338l1.322 1.343c.356.342.828.533 1.318.533.49 0 .961-.19 1.317-.533l1.974-2.005a.936.936 0 0 1 .675-.358.918.918 0 0 1 .713.273.946.946 0 0 1 .274.722.958.958 0 0 1-.349.687l-1.974 2.005a3.722 3.722 0 0 1-1.208.825c-.452.191-.937.29-1.427.291Zm.516-5.067a.895.895 0 0 0 .971-.193l5.707-5.705a.897.897 0 0 0-1.263-1.274l-5.707 5.705a.897.897 0 0 0 .292 1.467Z",
    fill: "currentColor",
    style: {
      fill: "#fff",
      fillOpacity: 1
    }
  }));
};

export default SvgLinkIcon;